import _wrapRegExp from "/azp/_work/3/s/node_modules/@babel/runtime/helpers/esm/wrapRegExp.js";
import _padStartInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/pad-start";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import { DATA_TYPE_OBJECT, DATA_TYPE_DATE_TIME } from '@jutro/prop-types';
import isString from "lodash/isString";
import isNumber from "lodash/isNumber";
import isDate from "lodash/isDate";
import { format, isEqual, isAfter, isBefore } from 'date-fns';
var SAMPLE_DATE = {
  YEAR: '1970',
  MONTH: '01',
  DAY: '15'
};
var PATTERN_MAP = {
  YEAR: 'yyyy',
  MONTH: 'MM',
  DAY: 'dd'
};
var SEPARATORS = ['/', '-', '.'];
var DDMMYYYY = /*#__PURE__*/_wrapRegExp(/^(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{1,4})(.*)$/, {
  d: 1,
  m: 2,
  y: 3,
  t: 4
});
var MMDDYYYY = /*#__PURE__*/_wrapRegExp(/^(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{1,4})(.*)$/, {
  m: 1,
  d: 2,
  y: 3,
  t: 4
});
var YYYYMMDD = /*#__PURE__*/_wrapRegExp(/^(\d{1,4})[/\-.](\d{1,2})[/\-.](\d{1,2})(.*)$/, {
  y: 1,
  m: 2,
  d: 3,
  t: 4
});
export function formatDateToDataType(date, dataType) {
  var includeTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var year = date.getTimezoneOffset() < 0 ? date.getFullYear() : date.getUTCFullYear();
  var month = date.getTimezoneOffset() < 0 ? date.getMonth() : date.getUTCMonth();
  var day = date.getTimezoneOffset() < 0 ? date.getDate() : date.getUTCDate();
  var hour = date.getTimezoneOffset() < 0 ? date.getHours() : date.getUTCHours();
  var minute = date.getTimezoneOffset() < 0 ? date.getMinutes() : date.getUTCMinutes();
  if (dataType === DATA_TYPE_OBJECT) {
    return includeTime ? {
      year: year,
      month: month,
      day: day,
      hour: hour,
      minute: minute
    } : {
      year: year,
      month: month,
      day: day
    };
  }
  if (includeTime) {
    return new Date(Date.UTC(year, month, day, hour, minute)).toISOString();
  }
  var dateString = new Date(Date.UTC(year, month, day)).toISOString();
  return dataType === DATA_TYPE_DATE_TIME ? dateString : dateString.substr(0, 10);
}
export function parseDateShapeToDate(value) {
  var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (isString(value) || isNumber(value) || isDate(value)) {
    var date = new Date(value);
    var _ref = [date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()],
      _year = _ref[0],
      _month = _ref[1],
      _day = _ref[2];
    return includeTime ? date : new Date(_year, _month, _day);
  }
  if (includeTime) {
    var _year2 = value.year,
      _month2 = value.month,
      _day2 = value.day,
      _value$hour = value.hour,
      hour = _value$hour === void 0 ? 0 : _value$hour,
      _value$minute = value.minute,
      minute = _value$minute === void 0 ? 0 : _value$minute;
    return new Date(_year2, _month2, _day2, hour, minute);
  }
  var year = value.year,
    month = value.month,
    day = value.day;
  return new Date(year, month, day);
}
export function isDateShapeInRange(dateShape, minDateShape, maxDateShape) {
  var date = parseDateShapeToDate(dateShape);
  var minDateObject = minDateShape ? parseDateShapeToDate(minDateShape) : null;
  var maxDateObject = maxDateShape ? parseDateShapeToDate(maxDateShape) : null;
  var meetsMinRequirement = !minDateObject || isEqual(date, minDateObject) || isAfter(date, minDateObject);
  var meetsMaxRequirement = !maxDateObject || isEqual(date, maxDateObject) || isBefore(date, maxDateObject);
  return meetsMinRequirement && meetsMaxRequirement;
}
export function getPatternFromLocale(locale) {
  var sampleDate = new Date("".concat(SAMPLE_DATE.YEAR, "-").concat(SAMPLE_DATE.MONTH, "-").concat(SAMPLE_DATE.DAY, "T00:00"));
  var pattern = format(sampleDate, 'P', {
    locale: locale
  });
  return pattern.replace(SAMPLE_DATE.YEAR, PATTERN_MAP.YEAR).replace(SAMPLE_DATE.MONTH, PATTERN_MAP.MONTH).replace(SAMPLE_DATE.DAY, PATTERN_MAP.DAY);
}
export function getInputDateFormats(pattern) {
  var dateFormats = _mapInstanceProperty(SEPARATORS).call(SEPARATORS, function (separator) {
    return pattern.replace(/[/\-.]/g, separator);
  });
  dateFormats.push('P');
  return dateFormats;
}
export function normalizeInput(input, datePattern) {
  var _match$groups, _match$groups2, _context, _match$groups3, _context2, _match$groups$t, _match$groups4;
  var getPattern = function getPattern() {
    switch (datePattern.charAt(0).toLowerCase()) {
      case 'd':
        return DDMMYYYY;
      case 'm':
        return MMDDYYYY;
      case 'y':
        return YYYYMMDD;
      default:
        break;
    }
    return DDMMYYYY;
  };
  var match = input.match(getPattern());
  if (!match) {
    return input;
  }
  var year = match === null || match === void 0 ? void 0 : (_match$groups = match.groups) === null || _match$groups === void 0 ? void 0 : _match$groups.y;
  var month = match === null || match === void 0 ? void 0 : (_match$groups2 = match.groups) === null || _match$groups2 === void 0 ? void 0 : _padStartInstanceProperty(_context = _match$groups2.m).call(_context, 2, '0');
  var day = match === null || match === void 0 ? void 0 : (_match$groups3 = match.groups) === null || _match$groups3 === void 0 ? void 0 : _padStartInstanceProperty(_context2 = _match$groups3.d).call(_context2, 2, '0');
  return "".concat(year, "-").concat(month, "-").concat(day).concat((_match$groups$t = match === null || match === void 0 ? void 0 : (_match$groups4 = match.groups) === null || _match$groups4 === void 0 ? void 0 : _match$groups4.t) !== null && _match$groups$t !== void 0 ? _match$groups$t : '');
}